import axios from "axios";
import { API_BASE_URL } from "../config/envConfig";

const axiosClient = axios.create({
    baseURL: API_BASE_URL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

let globalSignOut = null;
axiosClient.__setGlobalSignOut = (fn) => {
    globalSignOut = fn;
};

axiosClient.interceptors.request.use(
    (config) => {
        if (window.__accessToken) {
            config.headers.Authorization = `Bearer ${window.__accessToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let refreshPending = null;
let authResponse = null;
axiosClient.__setAuthResponse = callback => { authResponse = callback; };
axiosClient.__refreshSession = () => {
    if (!refreshPending) {
        refreshPending = axios.post(
            API_BASE_URL + '/api/auth/refresh', {}, {withCredentials:true}
        ).then(response => {
            window.__accessToken = response.data.accessToken;
            if (authResponse) authResponse(response.data);
            return response;
        }).finally(() => { refreshPending = null; });
    }
    return refreshPending;
};
const isAuthRequest = config => /\/api\/auth\/(login|refresh|logout)(?:[?]|$)/.test(config?.url || '');
axiosClient.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        if (error.response?.status !== 401 || !originalRequest || originalRequest._retry || isAuthRequest(originalRequest)) return Promise.reject(error);
        originalRequest._retry = true;
        // Another request may already have renewed the expired token.
        const token = window.__accessToken;
        if (token && originalRequest.headers?.Authorization !== 'Bearer ' + token) {
            originalRequest.headers = {...originalRequest.headers, Authorization:'Bearer ' + token};
            return axiosClient(originalRequest);
        }
        try {
            const response = await axiosClient.__refreshSession();
            originalRequest.headers = {...originalRequest.headers, Authorization:'Bearer ' + response.data.accessToken};
            return axiosClient(originalRequest);
        } catch (failure) {
            // Rate limits and temporary failures must not delete the refresh cookie.
            if (failure.response?.status === 401) {
                window.__accessToken = null;
                if (globalSignOut) await globalSignOut();
            }
            return Promise.reject(failure);
        }
    }
);

export default axiosClient;
